import { AxnAdminSession, FormattedAxnAdminSession } from "@idw-types/data/management-console/axnadmin";

export const formatAxnAdminSessions = (sessions: Array<AxnAdminSession>): Array<FormattedAxnAdminSession> => {
    return sessions.map(session => formatAxnAdminSession(session));
};

export const formatAxnAdminSession = (session: AxnAdminSession): FormattedAxnAdminSession => {
    let lastAccessDate = null;
    if (session.lastAccessDate) {
        lastAccessDate = new Date(parseInt(session.lastAccessDate));
    }
    let logInDate = null;
    if (session.logInDate) {
        logInDate = new Date(parseInt(session.logInDate));
    }
    return {
        email: session.email,
        firstName: session.firstName,
        lastAccessDate: lastAccessDate,
        lastName: session.lastName,
        logInDate: logInDate,
        organization: session.organization,
        role: session.role,
        token: session.token,
        userID: session.userID
    };
};